import Joi from "joi-browser";
import useConfigureForm from "../../useConfigureForm";

export default useWhatsappMessageActionForm;

export const whatsappMessageActionFormSchema = {
  name: Joi.string().required().label("Name"),
  description: Joi.string().allow("").label("Description"),
  assistantId: Joi.string().disallow("").required().label("Assistant"),
  phoneNumberField: Joi.string()
    .required()
    .disallow("")
    .label("Phone Number Mapping"),
  fromIdentifier: Joi.string().disallow("").required().label("From Number"),
  template: Joi.object({
    templateName: Joi.string().required(),
    templateLanguage: Joi.string(),
  }).required().label("Template"),
  attributes: Joi.object().allow({}).label("Attributes"),
};

export function getWhatsappMessageActionConfigureData(whatsappMessageAction) {
  return {
    name: whatsappMessageAction.name,
    description: whatsappMessageAction.description,
    assistantId: whatsappMessageAction.assistantId,
    phoneNumberField: whatsappMessageAction.inputMapping.phoneNumberField,
    fromIdentifier: whatsappMessageAction.fromIdentifier,
    template: JSON.stringify({
      templateName: whatsappMessageAction.templateName,
      templateLanguage: whatsappMessageAction.templateLanguage,
    }),
    attributes: whatsappMessageAction.inputMapping.attributesField ?? {},
  };
}

function useWhatsappMessageActionForm(whatsappMessageAction, validationErrors) {
  const { formState, errors, validate, updateFormState, setFormState } =
    useConfigureForm(
      () => getWhatsappMessageActionConfigureData(whatsappMessageAction),
      whatsappMessageActionFormSchema,
      validationErrors,
    );

  return {
    formState,
    errors,
    validate,
    updateFormState,
    setFormState,
  };
}
